<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds-from-desktop">
    <h1 class="govuk-heading-l">
      Sorry, there is a problem <span class="govuk-util__inline-block">with this service</span>
    </h1>
    <p>Try again later.</p>
    <p>If you need help you can <a [routerLink]="['/contact-us']">contact us</a>.</p>
  </div>
</div>
